// extracted by mini-css-extract-plugin
export var body = "_3q-1";
export var bodyPadded = "_3q-2";
export var chevron = "_3q-4";
export var chevronOpen = "_3q-5";
export var header = "_3q-0";
export var icon = "_3q-3";